module.exports = __webpack_public_path__ + "static/media/thumbnail_thankyoucard.09f9bd57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnail_thankyoucard.png
// module id = 113
// module chunks = 0